//Animation on scroll
function initAnimation(){
  const elems = document.querySelectorAll('[data-animate]');
  if (!elems.length) return;

  // rootMargin '-10% bottom' mirrors the previous scroll check:
  // positionFromTop <= windowHeight * 0.90 (element enters bottom 10% of viewport)
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.setAttribute('data-animated', '');
        observer.unobserve(entry.target);
      }
    }
  }, { rootMargin: '0px 0px -10% 0px' });

  for (const el of elems) {
    if (!el.hasAttribute('data-animated')) observer.observe(el);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  initAnimation();
}, false);

document.addEventListener('animation:init', initAnimation);